// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setActiveTab = createAction('[Custom PDF Report Builder] Set Active Tab', props());
